import { AddToCartProductStockUnavailable } from '@scalefast/core';
import { Observable, throwError } from 'rxjs';
import { APIv4CartLocalStorageAdapter } from '../../../Product/Infrastructure/Adapters/APIv4CartLocalStorageAdapter';
class V4LocalStorageCartRepository {
  constructor(context, checkoutConfig, storage) {
    this.context = context;
    this.checkoutConfig = checkoutConfig;
    this.storage = storage;
    this.storageExpire = 1000 * 60 * 60 * 24 * 7; // Not really implemented for local storage, just set for repository compliance
    this.pepStorageKey = this.context.pepStorageKey;
    this.cartKey = `cart_${this.context.territoryId}`;
  }
  /**
   * pep storage is the v4 localstorage/cookie object, it includes the cart and more stuff
   * This class modifies cart and treats the rest of the object as opaque
   */
  readPepStorage() {
    try {
      const pepStorageString = this.storage.get(this.pepStorageKey);
      if (!pepStorageString) {
        return null;
      }
      const pepStorage = JSON.parse(pepStorageString);
      return pepStorage;
    } catch (e) {
      console.error(e);
      return null;
    }
  }
  readPepStorageCart() {
    const pepStorage = this.readPepStorage();
    return pepStorage?.[this.cartKey] ?? [];
  }
  setPepStorageCart(cart) {
    let pepStorage = this.readPepStorage();
    if (!pepStorage) {
      pepStorage = {};
    }
    const pepCart = this.getPepCartFromProducts(cart);
    pepStorage[this.cartKey] = pepCart;
    this.storage.set(this.pepStorageKey, JSON.stringify(pepStorage), this.storageExpire);
  }
  getPepCartFromProducts(cart) {
    return cart.map(product => {
      return APIv4CartLocalStorageAdapter.mapCartProduct(product);
    });
  }
  static getCartFromProducts(products) {
    products.forEach(p => {
      p.quantity = parseInt(p.quantity);
      p.price = p.price || p.product?.price?.currencies?.find(c => c.currency == p.currency)?.prices?.[0]?.price;
    });
    //TODO: We should retrive the product from the API and update the cart
    products = products.filter(product => {
      // TODO: Price is not a required value as it could be found with an call to the product API
      if (product.productId && product.quantity > 0 && product.price !== undefined) {
        return true;
      }
      console.error(`Invalid product found in cart`, product);
      return false;
    });
    return {
      nbProducts: products.length,
      products,
      price: products.reduce((acc, product) => acc + product.price * product.quantity, 0)
    };
  }
  getCart() {
    const pepCart = this.readPepStorageCart();
    const cart = V4LocalStorageCartRepository.getCartFromProducts(pepCart);
    return new Observable(observer => {
      observer.next(cart);
      observer.complete();
    });
  }
  setCart(data) {
    const {
      products
    } = data;
    this.setPepStorageCart(products);
    return new Observable(observer => {
      const cart = V4LocalStorageCartRepository.getCartFromProducts(products);
      observer.next(cart);
      observer.complete();
    });
  }
  deleteCart() {
    this.storage.remove(this.cartKey);
    return new Observable(observer => {
      const cart = V4LocalStorageCartRepository.getCartFromProducts([]);
      observer.next(cart);
      observer.complete();
    });
  }
  addToCart(data) {
    const {
      products,
      product,
      cartToken,
      cartProvider
    } = data;
    let newCart = [];
    if (!products || !products.length) {
      newCart = [product];
    }
    const productIndex = products.findIndex(item => item.productId === product.productId);
    if (productIndex >= 0) {
      const newQuantity = products[productIndex].quantity + product.quantity;
      product.quantity = newQuantity;
      if (!product.stock) {
        return throwError(new AddToCartProductStockUnavailable('There is not enough stock for this product'));
      }
      if (newQuantity > product.stock) {
        products[productIndex].quantity = product.stock;
      } else {
        products[productIndex] = product;
      }
    } else {
      products.push(product);
    }
    newCart = products;
    return this.setCart({
      products: newCart,
      cartToken,
      cartProvider
    });
  }
  updateCart(data) {
    const {
      products,
      product,
      cartToken,
      cartProvider
    } = data;
    let newCart = [];
    const productIndex = products.findIndex(item => item.productId === product.productId);
    if (productIndex >= 0) {
      products[productIndex] = product;
    }
    newCart = products;
    return this.setCart({
      products: newCart,
      cartToken,
      cartProvider
    });
  }
  removeFromCart(data) {
    const {
      products,
      productId,
      cartToken,
      cartProvider
    } = data;
    let newCart = [];
    newCart = products.filter(item => item.productId !== productId);
    return this.setCart({
      products: newCart,
      cartToken,
      cartProvider
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getTaxes(data) {
    //TODO: probably it doesn't make sense CartRepository has this generic getTaxes method
    throw Error('V4LocalStorageCart for hybrid store does not implement this v5 taxes method.');
  }
}

export { V4LocalStorageCartRepository as default };